<main @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-body>
      <div class="popup-address">
        <form aria-labelledby="title">
          <div class="form-group">
            <div class="form-control-group">
              <app-dadata (selected)="onSelect($event)" i18n-placeholder="@@Address" placeholder="Адрес"></app-dadata>
            </div>
          </div>
          <button nbButton
                  status="primary"
                  type="button"
                  i18n="@@Save"
                  (click)="onSubmit()"
                  [disabled]="!selected()">
            Сохранить
          </button>
        </form>
      </div>
    </nb-card-body>
  </nb-card>
</main>
